import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
// import {isSafari} from 'react-device-detect';
import {useEffect, useState} from 'react';
import {Link, NavLink, useLocation} from 'react-router-dom';
// import {isSafari} from 'react-device-detect';
import {ReactComponent as InfluencerReportIcon} from '../../../../../assets/images/layout/account.svg';
import {ReactComponent as DashboardIcon} from '../../../../../assets/images/layout/dashboard.svg';
import {ReactComponent as LogoutIcon} from '../../../../../assets/images/layout/logout.svg';
import {ReactComponent as HelpIcon} from '../../../../../assets/images/layout/help.svg';
import {ReactComponent as CampaignListIcon} from '../../../../../assets/images/layout/campaignlist.svg';
import {ReactComponent as AccountSettingsIcon} from '../../../../../assets/images/layout/accountsettings.svg';
import nameLogo from '../../../../../assets/images/name_logo.svg';
import {useAuth} from '../../../../modules/auth';
import {routes} from '../../../../routing/routes';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import {useI18n} from '../../../providers/I18nProvider';
import HR from '../../HR';
import {useLayout} from '../LayoutProvider';
import {LogoutProps} from '../Types';
import {useCreateCampaignJourney} from '../../../../modules/campaign/pages/create/providers/CreateCampaignProvider';

export default function Sidebar({setShowLogoutModal}: LogoutProps) {
	const {currentUser} = useAuth();
	const {i18n} = useI18n();
	const {closeSidebar, setShouldShowNavbarAction} = useLayout();
	const {pathname, state} = useLocation();
	const {setCurrentStep} = useCreateCampaignJourney();

	const {height} = useWindowDimensions();

	const [menus, setMenus] = useState([
		{
			title: i18n('LAYOUT.SIDEBAR.MENU.DASHBOARD'),
			icon: DashboardIcon,
			route: routes.dashboard,
			isActive: false,
		},
		{
			title: i18n('LAYOUT.SIDEBAR.MENU.CAMPAIGN_LIST'),
			icon: CampaignListIcon,
			route: routes.campaign.list,
			isActive: false,
		},
		{
			title: i18n('LAYOUT.SIDEBAR.MENU.INFLUENCER_REPORT'),
			icon: InfluencerReportIcon,
			route: routes.campaign.influence,
			isActive: false,
		},
		{
			title: i18n('LAYOUT.SIDEBAR.MENU.ACCOUNT'),
			icon: AccountSettingsIcon,
			route: routes.accountSettingsRoutes.base,
			isActive: false,
		},
		{
			title: i18n('LAYOUT.SIDEBAR.MENU.HELP'),
			icon: HelpIcon,
			route: routes.help,
			isActive: false,
		},
	]);

	useEffect(() => {
		const isRouteActive = (route: string): boolean => {
			return pathname === route || pathname.startsWith(`${route}/`);
		};

		setMenus((prevMenus) => {
			return prevMenus.map((menu) => ({
				...menu,
				isActive: isRouteActive(menu.route),
			}));
		});
	}, [pathname]);

	if (!currentUser) return null;
	const handleMenuItem = (id: number) => {
		const updateMenus = menus.map((menu, index) => {
			const newMenu = {...menu};

			if (id === index) {
				newMenu.isActive = true;
			} else {
				newMenu.isActive = false;
			}
			return newMenu;
		});
		setMenus([...updateMenus]);
	};

	const handleNavbarAciton = (index: number) => {
		if (index === 2 || index === 3) {
			setShouldShowNavbarAction(true);
		} else {
			setShouldShowNavbarAction(false);
		}
	};

	const isEditOrCopy = state?.option === 'edit' || state?.option === 'copy';

	return (
		<div className='flex flex-col p-4 lg:p-6 min-h-full'>
			<div className='mb-4'>
				<img className='w-32 md:w-28 lg:w-40 xl:w-44' src={nameLogo} alt='Knower' />
				<hr className='mt-6 sm:hidden' />
			</div>
			<div className='flex flex-col bg-black-95 rounded-lg py-2 px-4 mb-8 break-all'>
				<h3 className='text-base md:text-sm lg:text-lg font-bold text-black-10 mb-1'>
					{currentUser.enterpriser?.companyName}
				</h3>
				<span className='text-base md:text-xs lg:text-lg'>{currentUser.enterpriser?.email}</span>
			</div>
			<div className='mb-4'>
				{menus.map((menu, index) => (
					<NavLink
						key={menu.title}
						className={clsx('flex items-center py-2 px-4 md:p-3 lg:p-4 rounded-lg mb-4', {
							'bg-[#F8F9FB]': menu.isActive,
						})}
						to={menu.route}
						onClick={() => {
							closeSidebar();

							handleNavbarAciton(index);
							handleMenuItem(index);
							window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
						}}
					>
						<menu.icon
							className={clsx('h-4.5 w-4.5 md:h-3.75 md:w-3.75 lg:h-4.5 lg:w-4.5 mr-4 md:mr-3.5 lg:mr-4', {
								'fill-primary [&>path]:fill-primary': menu.isActive,
								'fill-[#596573] [&>path]:fill-[#596573]': !menu.isActive,
							})}
						/>
						<span
							className={clsx('text-sm md:text-xs lg:text-base font-medium', {
								'text-primary': menu.isActive,
								'text-black-10': !menu.isActive,
							})}
						>
							{menu.title}
						</span>
					</NavLink>
				))}
			</div>

			<div className='flex mb-8'>
				<Link
					to={routes.campaign.create}
					onClick={() => {
						closeSidebar();
						if (pathname === '/campaign/create' && isEditOrCopy) {
							setCurrentStep?.(1);
							localStorage.setItem('currentStep', JSON.stringify(1));
							window.location.reload();
						}
					}}
					className='w-full rounded-full border border-primary text-primary text-center text-sm sm:text-base md:text-xs lg:text-base p-2'
				>
					<FontAwesomeIcon icon={faPlus} />
					<span className='ml-3 sm:ml-2 lg:ml-3 font-medium text-sm sm:text-xs lg:text-base'>
						{i18n('LAYOUT.SIDEBAR.CTA.NEW_CAMPAIGN')}
					</span>
				</Link>
			</div>

			<div
				className={clsx('sm:hidden', {
					'w-full': height <= 799,
					'w-[80%] absolute bottom-0 mb-10': height > 799,
					// 'mb-20': isSafari,
				})}
			>
				<div className='flex'>
					<HR />
				</div>

				<button
					className='w-full flex items-center p-4'
					onClick={() => {
						closeSidebar();
						setShowLogoutModal(true);
					}}
				>
					<LogoutIcon className='h-4.5 w-4.5 mr-4' />
					<span className='font-medium text-black-10'>{i18n('LAYOUT.HEADER.BUTTON.LOGOUT')}</span>
				</button>
			</div>
		</div>
	);
}
